import { getApp } from "firebase/app";
import { getFirestore, collection } from "firebase/firestore";

const app = getApp();

// =============================== BASE  ===============================  //

export const REF = {
  NAME: "payment",
  COLLECTIONS: {
    ORDER: "order",
  },
};

export const getRefs = () => {
  const firestore = getFirestore(app, REF.NAME);
  const CREF = {
    order: collection(firestore, REF.COLLECTIONS.ORDER),
  };
  return CREF;
};
